/**
 * @generated SignedSource<<02930a5b68540715164cca925e573a86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type getAccountTreesListSubscription$variables = {
  search?: string | null;
};
export type getAccountTreesListSubscription$data = {
  readonly sys_organization_account_trees: ReadonlyArray<{
    readonly account_tree_name: string;
    readonly organization: {
      readonly organization_label: string;
    } | null;
    readonly organization_account_tree_id: number;
    readonly updated_at_datetime: string;
  }>;
};
export type getAccountTreesListSubscription = {
  response: getAccountTreesListSubscription$data;
  variables: getAccountTreesListSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "%",
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_ilike",
                "variableName": "search"
              }
            ],
            "kind": "ObjectValue",
            "name": "account_tree_name"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_organization_account_trees",
    "kind": "LinkedField",
    "name": "sys_organization_account_trees",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organization_account_tree_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "account_tree_name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updated_at_datetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_organizations",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organization_label",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getAccountTreesListSubscription",
    "selections": (v1/*: any*/),
    "type": "subscription_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getAccountTreesListSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "33b8e2bf168e6913af55e9cfc6d48e9d",
    "id": null,
    "metadata": {},
    "name": "getAccountTreesListSubscription",
    "operationKind": "subscription",
    "text": "subscription getAccountTreesListSubscription(\n  $search: String = \"%\"\n) {\n  sys_organization_account_trees(where: {account_tree_name: {_ilike: $search}}) {\n    organization_account_tree_id\n    account_tree_name\n    updated_at_datetime\n    organization {\n      organization_label\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "828f3c9a2dcfe6f4d8d419e801c7ccb4";

export default node;
